import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateBarangayPayload {
  city_id: number;
  code: string;
  name: string;
  status: number;
}

export interface UpdateBarangayPaylod extends CreateBarangayPayload {}

export const BARANGAY_QUERY_KEY = ["barangay"];
export const VIEW_BARANGAY_QUERY_KEY = ["view-barangay"];

export const barangayService = {
  createBarangay: async (payload: CreateBarangayPayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/barangay", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showBarangay: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/barangay/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateBarangay: async (id: number, payload: UpdateBarangayPaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/barangay/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/barangay/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  getAllBarangay: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-barangay`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  getBarangayByCity: async (id: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/barangay/${id}/by-city`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
